import Cookies from "js-cookie";

const SESSION_DURATION_DAYS = 7;

// eslint-disable-next-line no-restricted-globals
const isSecureContext = window.location?.protocol === "https:";

const defaultCookieOptions = {
    expires: SESSION_DURATION_DAYS,
    sameSite: "Lax",
    secure: isSecureContext,
    path: "/"
};

/**
 * Drop-in replacement for localStorage that uses cookies with built-in TTL.
 *
 * - Auth cookies auto-expire after SESSION_DURATION_DAYS, preventing stale sessions.
 * - `Secure` flag is set automatically when served over HTTPS.
 * - `SameSite=Lax` prevents cookies from being sent with cross-site requests.
 * - If a value exceeds the ~4KB cookie limit, it fails gracefully with a warning.
 */
const cookieStorage = {
    getItem(key) {
        return Cookies.get(key) ?? null;
    },

    setItem(key, value) {
        try {
            const stringValue = String(value);
            Cookies.set(key, stringValue, defaultCookieOptions);
        } catch (error) {
            console.warn(
                `[cookieStorage] Failed to set cookie "${key}":`,
                error
            );
        }
    },

    removeItem(key) {
        // Remove from the current domain/path
        Cookies.remove(key, { path: "/" });

        // Also attempt removal from the root domain if on a subdomain (e.g., .mammothmenu.com)
        const host = window.location.hostname;
        const parts = host.split(".");
        if (parts.length > 2) {
            const domain = `.${parts.slice(-2).join(".")}`;
            Cookies.remove(key, { path: "/", domain });
        }
    }
};

export default cookieStorage;
